<template>
    <div id="map" style="width: 100%; height: 500px" class="mh-75"></div>
</template>

<script>
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import MapBox from '../mixins/MapBox/Map';

export default {
    mixins: [MapBox],
    props: {
        adminLang: {
            type: String,
            default: '',
        },
    },
    mounted() {
        if (this.mapData && this.markerSource && this.markerSource[0]) {
            this.mySmartMap.setMinZoom(this.mapData.min_zoom);
        }
        var self = this;
        this.mySmartMap.on('load', () => {
            if (this.adminLang === 'ja') {
                this.switchLanguage(this.adminLang)
            }
            if (self.mapData && this.markerSource && this.markerSource[0]) {
                self.mySmartMap.setZoom(self.mapData.zoom_level);
            }
        })
    },
};
</script>